import React from 'react';
export function Header() {
  return <header className="bg-brand-cream py-8 border-b border-brand-green/10" data-id="element-99">
      <div className="container mx-auto px-6 text-center" data-id="element-100">
        <div className="flex items-center justify-center gap-3 mb-2" data-id="element-101">
          <div className="w-10 h-10 rounded-full border-2 border-brand-gold flex items-center justify-center" data-id="element-102">
            <span className="font-serif font-bold text-brand-green text-lg" data-id="element-103">
              7
            </span>
          </div>
          <h1 className="font-serif text-2xl md:text-3xl font-bold text-brand-green tracking-wide" data-id="element-104">
            SCORE 700<sup className="text-xs text-brand-gold ml-1" data-id="element-105">™</sup>
          </h1>
        </div>
        <p className="text-brand-green/70 text-xs md:text-sm uppercase tracking-[0.3em] mb-3" data-id="element-106">
          Sistema de Crédito en USA
        </p>
        <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 text-sm text-brand-green/80" data-id="element-107">
          <span data-id="element-108">Fundamentos</span>
          <span className="text-brand-gold" data-id="element-109">•</span>
          <span data-id="element-110">Estrategia</span>
          <span className="text-brand-gold" data-id="element-111">•</span>
          <span data-id="element-112">Tarjetas</span>
          <span className="text-brand-gold" data-id="element-113">•</span>
          <span data-id="element-114">Sistema Completo</span>
        </div>
      </div>
    </header>;
}